import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { latitude, longitude } from '~/prix/types/presets/geo'
import sql from '~/prix/utils/sql'

export const emergencyDispatchObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().positive(),
  plusCode: z.string(),
  title: z.string(),
  observation: z.string().nullish(),
  latitude: latitude(),
  longitude: longitude(),
  residenceId: z.string().uuid().nullish(),
  fullAddress: z.string(),
  status: z.string(),
  sourceFilter: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  syncronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const emergencyDispatchCreateInputObject = z.object({
  id: z.string().uuid().nullish(),
  plusCode: z.string().min(1),
  title: z.string().min(1),
  observation: z.string().nullish(),
  latitude: latitude(),
  longitude: longitude(),
  residenceId: z.string().uuid().nullish(),
  fullAddress: z.string().min(1),
  status: z.string().min(1),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  syncronizedAt: dateOrIsoString().nullish(),
})

export const emergencyDispatchUpdateInputObject = z.object({
  id: z.string().uuid(),
  plusCode: z.string().min(1).optional(),
  title: z.string().min(1).optional(),
  observation: z.string().nullable().optional(),
  latitude: latitude().optional(),
  longitude: longitude().optional(),
  residenceId: z.string().uuid().nullable().optional(),
  fullAddress: z.string().min(1).optional(),
  status: z.string().min(1).optional(),
  updatedAt: dateOrIsoString().nullish(),
  syncronizedAt: dateOrIsoString().nullish(),
})

export type EmergencyDispatchType = z.infer<typeof emergencyDispatchObject>

export const propertyMap = {
  id: sql`emergency_dispatch.id`,
  code: sql`emergency_dispatch.code`,
  plusCode: sql`emergency_dispatch.plus_code`,
  title: sql`emergency_dispatch.title`,
  observation: sql`emergency_dispatch.observation`,
  latitude: sql`emergency_dispatch.latitude`,
  longitude: sql`emergency_dispatch.longitude`,
  residenceId: sql`emergency_dispatch.residence_id`,
  fullAddress: sql`emergency_dispatch.full_address`,
  status: sql`emergency_dispatch.status`,
  sourceFilter: sql`emergency_dispatch.source_filter`,
  createdAt: sql`emergency_dispatch.created_at`,
  updatedAt: sql`emergency_dispatch.updated_at`,
  syncronizedAt: sql`emergency_dispatch.syncronized_at`,
  deletedAt: sql`emergency_dispatch.deleted_at`,
}
